export default "/images/DLC.png?c2182eab6fef0a265869b1fcba3e4005";